addBrowserClass();

stickyFooter.init({
    selectorWrap: '[data-sticky-wrap]', // Selector for the wrap container (must use a valid CSS selector)
    selectorFooter: '[data-sticky-footer]', // Selector for the footer (must use a valid CSS selector)
    callback: function() {}, // Runs after the footer is stuck
});

$(function() {
    smoothScroll.init({
        selector: '[data-scroll]', // Selector for links (must be a class, ID, data attribute, or element tag)
        selectorHeader: '.l-header', // Selector for fixed headers (must be a valid CSS selector) [optional]
        speed: 500, // Integer. How fast to complete the scroll in milliseconds
        easing: 'easeInOutCubic', // Easing pattern to use
        offset: 64, // Integer. How far to offset the scrolling anchor location in pixels
        callback: function(anchor, toggle) {} // Function to run after scrolling
    });
    Tipped.create('.tipped');
    Tipped.create('#ajax-example', "Slowly!", {
        behavior: 'custom-slow',
        skin: 'mySkin',
        radius: false,
        padding: false,
        shadow: true,
        event: 'click'
    });
    Tipped.setDefaultSkin('mySkin');

    $('.tp-topicHolder__inner').owlCarousel({
        autoWidth: true,
        center: true,
        loop: true,
        mouseDrag: true,
        touchDrag: true,
        pullDrag: true,
        freeDrag: false,
        lazyLoad: true,
        rewind: true,
        margin: 30,
        nav: true,
        navText: ['<p class="st-navigate_left ss-navigateleft"></p>', '<p class="st-navigate_right ss-navigateright"></p>'],
        responsive: {
            0: {
                items: 1
            },
            320: {
                items: 1
            },
            640: {
                items: 2
            },
            960: {
                items: 3
            },
            1280: {
                items: 4
            },
            1600: {
                items: 5
            },
            1920: {
                items: 6
            }
        }
    });
    $('.tp-topicList__inner').owlCarousel({
        autoWidth: true,
        center: true,
        loop: true,
        mouseDrag: true,
        touchDrag: true,
        pullDrag: true,
        freeDrag: false,
        lazyLoad: true,
        rewind: true,
        margin: 30,
        nav: true,
        navText: ['<p class="st-navigate_left ss-navigateleft"></p>', '<p class="st-navigate_right ss-navigateright"></p>'],
        responsive: {
            0: {
                items: 1
            },
            320: {
                items: 1
            },
            640: {
                items: 2
            },
            960: {
                items: 3
            },
            1280: {
                items: 4
            },
            1600: {
                items: 5
            },
            1920: {
                items: 6
            }
        }
    });
});

$(document).on('click', '.btnClose', function(event) {
    $(this).parent().fadeOut("slow");
});

$('.data-link').click(function() {
    location.href = jQuery(this).attr('data-url');
});

$('.grid').isotope({
    itemSelector: '.grid-item',
    masonry: {
        fitWidth: true,
        columnWidth: 300,
        gutter: 30
    }
});

$('.grid.l-reportList__Body-innr').isotope({
    itemSelector: '.grid-item.c-reportListItem',
    masonry: {
        fitWidth: true,
        columnWidth: 144,
        gutter: 10
    }
});

$('.mc-reportBox__List').isotope({
    itemSelector: '.mc-reportBox__Entry',
    layoutMode: 'fitRows',
    percentPosition: true,
    fitRows: {
        columnWidth: '.grid-sizer',
        // gutter: '.gutter-sizer',
        fitWidth: true,
        gutter: 20
    }
});

$('.open-popup-link').magnificPopup({
    type: 'inline',
    showCloseBtn: false,
    modal: true,
    midClick: true // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.
});

$('.noteTrigger__innr-link').magnificPopup({
    type: 'inline',
    preloader: true,
    focus: true,
    showCloseBtn: false,
    enableEscapeKey: true
});

$('.anchorBox__Trigger-link').magnificPopup({
    type: 'inline',
    preloader: true,
    focus: true,
    showCloseBtn: false,
    enableEscapeKey: true
});

$('.sp-noteTrigger__Innr-link').magnificPopup({
    type: 'inline',
    preloader: true,
    focus: true,
    showCloseBtn: false,
    enableEscapeKey: true
});

$(document).on('click', '.popup-modal-dismiss', function(e) {
    e.preventDefault();
    $.magnificPopup.close();
});

$(function() {
    var target = $(".anchorBox");
    var footer = $(".noteTrigger");
    var targetHeight = target.outerHeight(true);
    var targetTop = target.offset().top;

    $(window).scroll(function() {
        var scrollTop = $(this).scrollTop();
        if (scrollTop > targetTop) {
            var footerTop = footer.offset().top;
            //スクロール
            if (scrollTop + targetHeight > footerTop) {
                customTopPosition = footerTop - (scrollTop + targetHeight)
                target.css({
                    position: "fixed",
                    top: customTopPosition + "px"
                });
            } else {
                //スクロール
                target.css({
                    position: "fixed",
                    top: "264px"
                });
            }
        } else {
            //初期状態
            target.css({
                position: "fixed",
                top: "264px"
            });
        }
    });
});

$(function() {
    var set = 180; //ウインドウ上部からどれぐらいの位置で変化させるか
    var boxTop = new Array;
    var current = -1;
    //各要素の位置
    $('.c_box').each(function(i) {
        boxTop[i] = $(this).offset().top;
    });
    //最初の要素にclass="on"をつける
    changeBox(0);
    //スクロールした時の処理
    $(window).scroll(function() {
        scrollPosition = $(window).scrollTop();
        for (var i = boxTop.length - 1; i >= 0; i--) {
            if ($(window).scrollTop() > boxTop[i] - set) {
                changeBox(i);
                break;
            }
        };
    });
    //ナビの処理
    function changeBox(secNum) {
        if (secNum != current) {
            current = secNum;
            secNum2 = secNum + 1; //HTML順序用
            $('.anchorBox li').removeClass('on');
            $('.anchorBox li:nth-child(' + secNum2 + ')').addClass('on');
            /* 位置によって個別に処理をしたい場合　
            if (current == 0) {
              // 現在地がsection1の場合の処理
            } else if (current == 1) {
              // 現在地がsection2の場合の処理
            } else if (current == 2) {
              // 現在地がsection3の場合の処理
            }*/
        }
    };
});

$(".js-goodTrigger").click(function() {
    $(this).toggleClass("is-active");
});

$("li.st-breadcrumb__entry").each(function() {
    //12文字以上になったら
    if ($(this).text().length > 12) {
        //27文字まで表示する、という設定
        $(this).text($(this).text().substr(0, 9));
        //27文字以降に表示する代替テキスト
        $(this).append('...');
    }
});
